
import apiSlice from "./ApiSlice";
import { v4 as uuid } from "uuid";

const deviceId = localStorage.getItem("deviceId") || uuid();

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Login
    login: builder.mutation({
      query: (body: { email: string; password: string }) => {
        return {
          url: "/admin/login",
          method: "POST",
          headers: {
            "device-id": deviceId,
          },
          body,
        };
      },
      transformResponse: (response: any) => {
        return { ...response, data: { ...response?.data, deviceId } };
      },
    }),

    // Get Access Token
    getAccessToken: builder.mutation({
      query: (body) => {
        return {
          url: "/admin/refresh",
          method: "POST",
          headers: {
            "device-id": deviceId,
          },
          body,
        };
      },
    }),
    // Change Password
    changePassword: builder.mutation({
      query: (body) => {
        return {
          url: "/admin/change-password",
          method: "PUT",
          headers: {
            "device-id": deviceId,
          },
          body,
        };
      },
    }),
    resetPassword: builder.mutation({
      query: ({body, id}) => {
        return {
          url: `/admin/reset-password/${id}`,
          method: "PUT",
          body,
        };
      },
    }),   

  }),
});

export const {
  useLoginMutation,
  useResetPasswordMutation,
  useGetAccessTokenMutation,
  useChangePasswordMutation,
} = authApi;
